import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function registrationStart() {
  pushClevertapEvent('Registration Start');
}

export function registrationBusinessInfo({ email }) {
  pushClevertapEvent('Registration Sign Up', { email });
}

export function clevertapTracker(event, data) {
  pushClevertapEvent(event, data);
}

export function registrationCompleted({ user, business }) {
  pushClevertapEvent('Registration Create Business', {
    Email: user.email,
    'First Name': user.first_name,
    'Last Name': user.last_name,
    Phone: user.phone,
    'Business Name': business.name,
    'Business Type ID': business.business_type_id,
    // 'Business Type Name': '',
    'Business Category ID': business.business_category_id,
    // 'Business Category Name':'',
    'Business Address': business.address,
    'Business City': business.city,
    'Business State': business.state,
    'Business Zip': business.postal_code,
  });
}

export function resendVerificationEmail({ email }) {
  pushClevertapEvent('Resend Verification Email', { email });
}
